import { render, staticRenderFns } from "./FrequentlyAskedQuestion.vue?vue&type=template&id=21a47926&scoped=true&"
import script from "./FrequentlyAskedQuestion.vue?vue&type=script&lang=js&"
export * from "./FrequentlyAskedQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyAskedQuestion.vue?vue&type=style&index=0&id=21a47926&prod&scoped=true&lang=css&"
import style1 from "./FrequentlyAskedQuestion.vue?vue&type=style&index=1&id=21a47926&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a47926",
  null
  
)

export default component.exports